import React from 'react';
import { User, CreditCard, Tag } from 'lucide-react';

/**
 * Секция формы с налоговым статусом и режимом налогообложения
 */
const TaxStatusSection = ({ 
  formData, 
  handleInputChange, 
  errors,
  fiscalRoles,
  taxSystems
}) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
      {/* Налоговый статус (физ. лицо или ИП) */}
      <div>
        <label htmlFor="fiscalRole" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
          <User className="w-4 h-4 mr-2 text-indigo-500" />
          Налоговый статус
        </label>
        <select
          id="fiscalRole"
          name="fiscalRole"
          value={formData.fiscalRole}
          onChange={handleInputChange}
          className={`form-select w-full ${errors.fiscalRole ? 'input-error' : ''}`}
        >
          {fiscalRoles.map((role) => (
            <option key={role.id} value={role.id}>
              {role.name}
            </option>
          ))}
        </select>
        {errors.fiscalRole && (
          <p className="mt-1 text-xs text-red-500 dark:text-red-400">
            {errors.fiscalRole}
          </p>
        )}
      </div>

      {/* Налоговый режим */}
      <div>
        <label htmlFor="taxSystem" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
          <Tag className="w-4 h-4 mr-2 text-indigo-500" />
          Налоговый режим
        </label>
        <select
          id="taxSystem"
          name="taxSystem"
          value={formData.taxSystem}
          onChange={handleInputChange}
          className={`form-select w-full ${errors.taxSystem ? 'input-error' : ''}`}
        >
          {taxSystems.map((system) => (
            <option key={system.id} value={system.id}>
              {system.name} ({system.rate})
            </option>
          ))}
        </select>
        {errors.taxSystem && (
          <p className="mt-1 text-xs text-red-500 dark:text-red-400">
            {errors.taxSystem}
          </p>
        )}
      </div>

      {/* Информация о статусе ИП */}
      {formData.fiscalRole === 'entrepreneur' && (
        <div className="col-span-full bg-gray-50 dark:bg-gray-800/30 p-3 rounded-lg border border-gray-200 dark:border-gray-700 mb-2">
          <div className="flex flex-col sm:flex-row sm:items-center gap-3">
            <div className="flex-1">
              <label className="inline-flex items-center">
                <input
                  type="checkbox"
                  name="hasActiveIP"
                  checked={formData.hasActiveIP}
                  onChange={handleInputChange}
                  className="form-checkbox"
                />
                <span className="ml-2 text-sm text-gray-700 dark:text-gray-300">
                  У меня действующий статус ИП
                </span>
              </label>
            </div>
            <div className="flex-1">
              <label htmlFor="ipRegistrationYear" className="block text-sm text-gray-700 dark:text-gray-300 mb-1">
                Год регистрации ИП
              </label>
              <select
                id="ipRegistrationYear"
                name="ipRegistrationYear"
                value={formData.ipRegistrationYear}
                onChange={handleInputChange}
                className="form-select text-sm py-1.5"
                disabled={!formData.hasActiveIP}
              >
                {Array.from({ length: 10 }, (_, i) => new Date().getFullYear() - i).map(year => (
                  <option key={year} value={year}>{year}</option>
                ))}
              </select>
            </div>
          </div>
          {formData.hasActiveIP && (
            <div className="mt-2 text-xs text-indigo-600 dark:text-indigo-400">
              <p>Для ИП будут учтены фиксированные страховые взносы в расчетах.</p>
            </div>
          )}
        </div>
      )}

      {/* Тип дохода (только для НПД) */}
      {formData.taxSystem === 'npd' && (
        <div className="col-span-full bg-indigo-50 dark:bg-indigo-900/20 p-3 rounded-lg border border-indigo-100 dark:border-indigo-800 mt-3">
          <div className="text-sm font-medium text-gray-900 dark:text-white mb-3">Тип дохода для самозанятых (НПД)</div>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
            <label className="relative flex items-center">
              <input
                type="radio"
                name="incomeType"
                value="general"
                checked={formData.incomeType === 'general'}
                onChange={handleInputChange}
                className="form-radio"
              />
              <div className="ml-2">
                <div className="text-sm font-medium text-gray-900 dark:text-white">От физических лиц</div>
                <div className="text-xs text-gray-500 dark:text-gray-400">Ставка 4%</div>
              </div>
            </label>
            <label className="relative flex items-center">
              <input
                type="radio"
                name="incomeType"
                value="ip_insurance"
                checked={formData.incomeType === 'ip_insurance'}
                onChange={handleInputChange}
                className="form-radio"
              />
              <div className="ml-2">
                <div className="text-sm font-medium text-gray-900 dark:text-white">От юридических лиц и ИП</div>
                <div className="text-xs text-gray-500 dark:text-gray-400">Ставка 6%</div>
              </div>
            </label>
          </div>
          {errors.incomeType && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.incomeType}
            </p>
          )}
        </div>
      )}
    </div>
  );
};

export default TaxStatusSection;